module.exports = __webpack_public_path__ + "static/img/yuqi-bg3.a0094c48.png";